<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        list: [],
        list_position: []
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchUnit()
        this.fetchPosition()
      },
      async fetchUnit () {
        let params = {
          limit: 100000
        }

        this.list = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },
      async fetchPosition () {
        let params = {
          limit: 100000
        }

        this.list_position = [
          {
            text: 'Semua',
            value: '0'
          }
        ]

        await get('admin/user_position', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list_position.push({
                text: obj.title,
                value: obj.id
              })
            })
          }
        })
      },
      config () {
        return {
          // CONFIG PARSING API
          api: 'admin/user_position',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Posisi',
              width: '300px',
              value: 'title',
              freeze: false,
              hide: false
            },
            {
              text: 'Deskripsi',
              width: '400px',
              value: 'job_desc',
              freeze: false,
              hide: false
            },
            {
              text: 'Unit',
              width: '300px',
              value: 'unit_name',
              freeze: false,
              hide: false,
              align: 'center'
            },
            {
              text: 'Parent ID',
              width: '120px',
              value: 'par_id',
              freeze: false,
              hide: false,
              align: 'center'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'unit_id',
              label: 'Unit',
              type: 'select_unit',
              placeholder: 'Contoh. Kantor Pusat SDM',
              value: '',
              option: this.list,
              width: '60%',
              required: true,
              rules: 'required',
              sub_select: 'position_id',
              api: 'admin/user_position'
            },
            {
              field: 'par_id',
              label: 'Posisi Diatasnya',
              type: 'select_position',
              placeholder: 'Contoh. Developer',
              value: '',
              option: this.list_position,
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'title',
              label: 'Posisi',
              type: 'text',
              placeholder: 'Contoh. Programmer',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'job_desc',
              label: 'Deskripsi',
              type: 'textarea',
              placeholder: 'Contoh. Bergelut dalam pengkodean aplikasi',
              value: '',
              width: '100%',
              rows: 3,
              required: false
            }
          ],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: true,
              api: 'admin/user_position/add',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'admin/user_position/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'admin/user_position/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            reset: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>